import Overlay from '../ui/overlay';
import Button from '../form/button';
import Route from '../route';
import * as activityLogger from "../helpers/activity-logger";

import { MAIN, SAVE_FOR_LATER } from './basket_types';
import initializeBillingAddressForm from './billing_address.js';
import initializeDeliveryAddress from './delivery_address.js';
import initializeStorageLocationForm from './storage_location.js';
import loadAdyenDropin from './load_adyen_dropin.js';
import highlightTermsAndConditions from './terms_and_conditions.js';

let basketOverlay = new Overlay('basket_popup--overlay');

$(function () {
    if (Route === "mybasket") {

        if ($('.shipping-method-tabs').length) {
            initializeBillingAddressForm();
            initializeDeliveryAddress();
            initializeStorageLocationForm();
        }

        // Remove item from Basket page
        $(document).on("click", ".remove-item", function (e) {

            if (!$(this).hasClass("clicked")) {

                $(this).addClass("clicked");

                let $removeItem = new Button(this);
                // show loading on remove item element
                $removeItem.showSpinner();

                $.ajax({
                    url: "/my-basket/ajax/remove-product",
                    method: "POST",
                    data: {
                        basketItemId: $(this).data("basket-item-id"),
                        basketType: MAIN,
                    },
                    success: function (response) {
                        if (response.success) {
                            if (response.cartCount !== undefined) {
                                $('.basket_icon').attr('data-basket-count', response.cartCount);

                                // Remove chosen item from the list
                                e.target.closest(".product__row").remove();

                                if (response.cartCount === 0) {
                                    location.reload();
                                }
                            }

                            // hide loading on delete button
                            $removeItem.hideSpinner();
                        }

                        loadAdyenDropin();
                    },
                    error: function (response) {
                        $removeItem.hideSpinner();
                    },
                });
            }
        });

        $(document).on("click", ".save-for-later", function (e) {
            if (!$(this).hasClass("clicked")) {

                $(this).addClass("clicked");

                let $saveItem = new Button(this);
                // show loading on save for later button
                $saveItem.showSpinner();

                let $productRow = $(this).closest(".product__row");

                axios.post('/my-basket/ajax/move-basket-item', {
                    basketItemId: $(this).data("basket-item-id"),
                    basketType: SAVE_FOR_LATER,
                })
                    .then(function (response) {
                        let $successNotification = $(response.data.html);

                        if (response.data.success) {
                            $productRow.empty();
                            $productRow.append($successNotification);

                            setTimeout(function () {
                                $successNotification.remove();
                                $productRow.remove();
                            }, 6000);

                            if (response.data.cartCount !== undefined) {
                                $('.basket_icon').attr('data-basket-count', response.data.cartCount);

                                if (response.data.cartCount === 0) {
                                    location.reload();
                                }
                            }

                            if (response.data.cartCount > 0) {
                                // Create saved tab
                                axios.get('/my-basket/ajax/get-saved-item-icon').then(response => {
                                    if ($('.saved-item-tab').length) {
                                        $('.saved-item-tab').replaceWith(response.data.html);
                                    } else {
                                        $('.basket_page .container-lg').prepend(response.data.html);
                                    }
                                })
                                    .catch(error => {
                                        // Handle error
                                        console.error('Error fetching delivery address:', error);
                                    });
                            }
                        }

                        if (response.data.cartCount > 0) {
                            loadAdyenDropin();
                        }
                    })
                    .finally(function () {
                        $saveItem.hideSpinner();
                    });
            }
        });

        // initial load
        loadAdyenDropin();

        $('select[name="slAccountCode"]').on('change', () => {
            loadAdyenDropin();
        });

        $(".shipping-method-tabs li").on("click", function () {
            loadAdyenDropin();
        });

        $(document).on('change', '.product__options--quantity select[name="quantity"]', function () {

            $("body").css("cursor", "progress");

            const data = {
                basketItemId: $(this).data("basket-item-id"),
                qty: $(this).val(),
                basketType: MAIN
            };

            axios.post('/my-basket/ajax/update-basket-item', data)
                .then(response => {
                    if (response.data.success === 1) {
                        loadAdyenDropin();

                        axios.get('/my-basket/ajax/get-basket-rows').then(response => {
                            $('.order_summary').replaceWith(response.data.html);

                        }).finally(() => {
                            $("body").css("cursor", "default");
                        });
                    }
                })
                .catch(error => {
                    // Handle error
                    console.error('There was an error updating the basket item:', error);
                });
        });

        $('form#deliveryInstructionsForm').on('submit', function (e) {
            e.preventDefault();
            let instructions = $('textarea[name="deliveryInstructionsInput"]').val();
            $('.delivery__instructions--text').html(instructions);
            $('#deliveryInstructionsAccordion').collapse('hide');
            $('.delivery__instructions--container button.add_edit_manage--btn').html('Edit');
            loadAdyenDropin();
        });

        $('#login-text').on('click', function (e) {
            $('#login-warning').removeClass('d-none');
        });
    }
});

$("body").on("submit", ".stockform", function (e) {
    e.preventDefault();
    var $form = $(this);

    let button = new Button($('button', $form));
    button.showSpinner();

    if (!$form.hasClass("processing")) {
        $form.addClass("processing");
        var csCondition = $(this).data("csCondition");
        var source = $(this).data("source"); // 'bistock', 'wfstock', 'broking','ltstockbuy','ltstocksell'
        var isForDelivery = $(this).data("forDelivery");
        let pack = $(this).data("pack");
        let itemId = $(this).data("itemId");
        let duty = $(this).data("duty");
        let etaDate = $(this).data("etaDate");
        let productCategory = $(this).data("productCategory");
        let bottleConditionCode = $(this).data("bottleConditionCode");
        let sellPrice = $(this).data("sellPrice");

        var qtyBtls = 0;

        if ($('select[name="qtycs"]', this).length) {
            var qtyBtls = $('select[name="qtycs"]', this).val() * pack;
        }
        if ($('select[name="qtybtls"]', this).length) {
            var qtyBtls = $('select[name="qtybtls"]', this).val();
        }

        let basketData = {
            qty: {
                qtyBtls: qtyBtls
            },
            stock: {
                itemId: itemId, // 12653
                productStatus: duty, // IB
                pack: pack, // 6
                etaDate: etaDate, // In Stock
                caseCondition: csCondition, // Original Case
                productCategory: productCategory, // WINE
                bottleConditionCode: bottleConditionCode, // WINE
                sellPrice: sellPrice
            },
            source: source, // 'bistock', 'wfstock', 'broking','ltstockbuy','ltstocksell'
            delivery: isForDelivery,
            page: $('body').data('route')
        };

        axios({
            method: 'post',
            url: "/my-basket/ajax/add-to-basket",
            data: basketData
        })
            .then(function (response) {
                var res = response.data;

                var quantity = res.cartCount;
                if (parseInt(quantity) > 0) {
                    $('.basket_icon').addClass('has-products').attr('data-basket-count', quantity);
                }

                $("#basketPopup").replaceWith(
                    res.html
                );

                $("#basketPopup").show();
                basketOverlay.show();

                $form.removeClass("processing");
                button.hideSpinner();
            })
            .catch(function (response) {
                var res = response.data;
                $("#basketPopup").show();
                basketOverlay.show();
                $(".response", "#basketPopup").html(
                    res.message
                );
            });
    }
    return false;
});

// Hide the Basket popup and overlay when the close basket popup button is clicked
$(document).on("click", "[data-hide-basket-popup-trigger]", function () {
    basketOverlay.hide();
    $(this).closest("[data-hide-basket-popup]").hide(); // hides the popup
});

// Hide the Basket popup and overlay when area outside is clicked
$(document).on("click", ".basket_popup--overlay", function () {
    basketOverlay.hide();
    $("#basketPopup").hide();
});

$(function () {
    $(document).on('submit', 'form[name="paylater"]', function (e) {
        if ($('#accept_terms').length && !$('#accept_terms').is(':checked')) {
            highlightTermsAndConditions();
            e.preventDefault();
            return;
        } else {
            let buttonElem = $(this).find(':input[type=submit]');
            buttonElem.addClass('disabled');
            let button = new Button(buttonElem);
            button.turnLoadingOn();
            $("body").css("cursor", "progress");
        }
    });
})
